import React from "react";
import { List, Datagrid, TextField, Filter } from "react-admin";
import RangeDatePicker from "../components/inputs/RangeDatePicker/RangeDatePicker";

const RepresentativesFilter = (props) => (
  <Filter {...props}>
    <RangeDatePicker
      source="startDatetimeFrom"
      alwaysOn
      filterValues={props.filterValues}
    />
  </Filter>
);

/* we use perPage={10000} because we don't want to use pagination here. */
export default (props) => (
  <List
    title="All representatives"
    {...props}
    perPage={10000}
    filters={<RepresentativesFilter />}
    bulkActionButtons={false}>
    <Datagrid>
      <TextField source="representative" />
      <TextField source="requests" label="Cargo requests" />
      <TextField source="matches" />
      <TextField source="shadows" label="Empty rides" />
      <TextField source="commutes" label="Roster rides" />
      <TextField source="companies" label="Active companies" />
      <TextField source="newCompaniesCount" label="New Companies" />
      <TextField source="newBeneficiaries" label="New Beneficiaries" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/representatives/List.js